import { NaturalPerson } from "@/models/proposal.model";
import { axiosInstance, axiosConsignadoInstance } from "./axiosInstance";

export const getNaturalPersonById = async (id: string):Promise<NaturalPerson | null> => {
    const response = await axiosInstance.get(`/api/v2/natural-person/${id}`)
    return response.data;
}

export const blacklistNaturalPerson = async (naturalPersonId: string): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.patch(
      `/api-consignado-trabalhador/v1/pessoa-natural/blacklist`,
      { naturalPersonId }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar pessoa à blacklist:", error);
    throw error;
  }
};